import { Link } from 'react-router-dom'
import classes from './ChatWidget.module.scss'
import { IconChevron } from './icons'
import { ChatNavigationAction } from './types'

interface Props {
  actions: ChatNavigationAction[]
  onNavigate?: () => void
}

/** Backend allow-list'inden gelen portal ekranlarını yalnız kullanıcı tıklamasıyla SPA içinde açar. */
export default function NavigationActions({ actions, onNavigate }: Props) {
  if (actions.length === 0) return null

  return (
    <nav className={classes.navigationActions} aria-label='Portal ekranı yönlendirmeleri'>
      {actions.map(action => (
        <Link
          key={`${action.path}-${action.label}`}
          className={classes.navigationAction}
          to={action.path}
          onClick={onNavigate}
        >
          <span>{action.label}</span>
          <span className={classes.navigationActionIcon} aria-hidden='true'>
            <IconChevron />
          </span>
        </Link>
      ))}
    </nav>
  )
}
